module.exports = __webpack_public_path__ + "static/img/certificate_img23.e6091e91.jpg";